import React from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import { Container, Columns, Column } from '@resurs/midas-react'
import PaymentPerMonth from '../shared/PaymentPerMonth'
import Order from './Invoice/Order'
import PaymentMethodHeader from './PaymentMethodHeader'
import { isResursPaymentMethod } from '../../../../models/payment-methods'

const Invoice = ({
  selectedPaymentMethod,
  limit,
  data,
  onOrderChanged,
  invoiceRef,
  customerType,
  orderIdValidation,
  orderIdValid,
  paymentMethodsExist,
}) => (
  <Container>
    <Columns>
      <Column col12>
        <PaymentMethodHeader description={selectedPaymentMethod.description}>
          <Conditional when={isResursPaymentMethod(selectedPaymentMethod.type)}>
            <PaymentPerMonth
              method={selectedPaymentMethod}
              amount={limit}
              customerType={customerType}
              paymentMethodsExist={paymentMethodsExist}
            />
          </Conditional>
        </PaymentMethodHeader>
      </Column>
      <Column col12>
        <div style={{ border: '1px solid lightgrey', padding: '2rem' }}>
          <Order
            data={data}
            orderIdValid={orderIdValid}
            orderIdValidation={orderIdValidation}
            onChange={orderData => onOrderChanged(orderData)}
            invoiceRef={invoiceRef}
            selectedPaymentMethod={selectedPaymentMethod}
          />
        </div>
      </Column>
    </Columns>
  </Container>
)

Invoice.propTypes = {
  selectedPaymentMethod: PropTypes.object.isRequired,
  limit: PropTypes.number,
  data: PropTypes.object.isRequired,
  onOrderChanged: PropTypes.func.isRequired,
  invoiceRef: PropTypes.bool.isRequired,
  customerType: PropTypes.string.isRequired,
  orderIdValidation: PropTypes.func,
  orderIdValid: PropTypes.bool,
  paymentMethodsExist: PropTypes.bool,
}

Invoice.defaultProps = {
  limit: null,
  orderIdValidation: () => {},
  orderIdValid: true,
  paymentMethodsExist: false,
}

export default Invoice
